const _import = require('../import-' + process.env.NODE_ENV)

const priceTagRouter = [
  {
    path: '/inspect/index',
    name: 'inspectIndex',
    component: _import('inspect/index'),
    meta: {
      title: '巡场系统', // 首页
      auth: true
    }
  },
  {
    path: '/inspect/newOrder',
    name: 'inspectNewOrder',
    component: _import('inspect/newOrder'),
    meta: {
      title: '巡场-新增单据',
      auth: true
    }
  },
  {
    path: '/inspect/feedback',
    name: 'inspectFeedback',
    component: _import('inspect/feedback'),
    meta: {
      title: '巡场-整改反馈',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/inspect/published',
    name: 'inspectPublished',
    component: _import('inspect/published'),
    meta: {
      title: '巡场-我发表的',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/inspect/list',
    name: 'inspectList',
    component: _import('inspect/list'),
    meta: {
      title: '巡场列表',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/inspect/report',
    name: 'inspectReport',
    component: _import('inspect/report'),
    meta: {
      title: '巡场统计',
      auth: true
    }
  },
  {
    path: '/inspect/detail',
    name: 'inspectDetail',
    component: _import('inspect/detail'),
    meta: {
      title: '巡场详情',
      auth: true
    }
  }
]
export default priceTagRouter



// WEBPACK FOOTER //
// ./src/router/work/inspect.js